import { styled } from '@linaria/react';

import { normalize } from '@/utils';

import Demo, { DemoSliderControl } from '@/components/Demo';
import Paper from '@/components/Paper';

import { CODE_BACKGROUND } from './index.constants';
import Element from './Element';

function GridTwoLine({ codeOutput }) {
  return (
    <Demo
      initialValues={{
        containerWidth: 100,
        containerHeight: 100,
      }}
      controlPosition="top"
      customGrid={{ gridTemplateColumns: '1fr 1fr' }}
      outputWrapper={null}
      controls={[
        <DemoSliderControl
          key="containerWidth"
          id="containerWidth"
          label="Container Width"
          min={25}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
        <DemoSliderControl
          key="containerHeight"
          id="containerHeight"
          label="Container Height"
          min={30}
          max={100}
          previewRenderer={(val) => `${val}%`}
        />,
      ]}
    >
      {({ containerWidth, containerHeight }) => {
        const containerHeightPx = normalize(
          containerHeight,
          30,
          100,
          70,
          200
        );
        return (
          <>
            <Row>
              <Column>{codeOutput}</Column>
              <DemoColumn>
                <Container
                  style={{
                    width: containerWidth + '%',
                    height: containerHeightPx,
                  }}
                >
                  <FlexElement>.element</FlexElement>
                </Container>
              </DemoColumn>
            </Row>
          </>
        );
      }}
    </Demo>
  );
}

const Row = styled.div`
  display: flex;
  gap: 24px;
  padding-bottom: 16px;

  @media (max-width: 34rem) {
    flex-direction: column-reverse;
    align-items: center;
  }
`;
const Column = styled.div`
  position: relative;
  flex: 1;
  background: ${CODE_BACKGROUND};
  border-radius: 8px;
  width: 100%;
  max-width: 332px;
`;

const DemoColumn = styled(Column)`
  display: flex;
  justify-content: center;
  min-height: 200px;
`;

const Container = styled(Paper)`
  position: relative;
  display: grid;
  place-content: center;
  padding: 16px 0px;
`;

const FlexElement = styled(Element)`
  height: 6rem;
`;

export default GridTwoLine;
